import { render, staticRenderFns } from "./ChatMessageList.vue?vue&type=template&id=bab8330e&scoped=true&"
import script from "./ChatMessageList.vue?vue&type=script&lang=js&"
export * from "./ChatMessageList.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageList.vue?vue&type=style&index=0&id=bab8330e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab8330e",
  null
  
)

export default component.exports